
jQuery(function ($) {
    var expireDays = 1;
    var now  = Math.round(new Date().getTime() / 1000);

    try {
        var data = JSON.parse(localStorage.getItem('urgency-overlay-closed') || '{}');

        if (data && data.expires && data.expires > now) {
            return;
        }
    }catch (e) {
    }

    $('[data-container=urgencyOverlay]').removeClass('urgency-overlay__hide');

    $(document).on('click', '[data-toggle=urgencyAcknowledge]', function (e) {
        localStorage.setItem('urgency-overlay-closed', JSON.stringify({
            expires: now + (expireDays * 86400)
        }));

        $(e.target).closest('[data-container=urgencyOverlay]').addClass('urgency-overlay__hide');

        e.preventDefault();
    })
});
